module.exports = __webpack_public_path__ + "img/5.51a9df87.png";